import { TrendingUp } from "lucide-react";
import { EmptyState } from "@/components/shared/empty-state";
import { PageHeader } from "@/components/shared/page-header";

export function HRSuccessionPlanningPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="Succession Planning"
        description="Who's ready to step into key roles, and who's being developed for them."
      />
      <EmptyState
        icon={TrendingUp}
        heading="Nothing tracked here yet"
        description="This page is ready to build out — named successors per role, readiness notes, whatever you want tracked."
      />
    </div>
  );
}
